// Server-authoritative hold countdown (Master Update Parts A4/A5).
//
// The ONLY inputs are the booking's two absolute UTC instants —
// hold_expires_at and server_now (ISO-8601 with "Z"). The device/server clock
// offset is derived ONCE at sync time; from then on the timer runs off
// Date.now() + offset, so a skewed browser clock, browser timezone changes,
// or DST never affect the displayed duration. Listing-local start/end play no
// role here — this timer means "time until the checkout hold expires", never
// the parking reservation duration.
import { useEffect, useRef, useState } from "react";

export function computeHoldRemaining(booking, syncDeviceMs, nowMs) {
  if (!booking?.hold_expires_at) return null;
  const expiry = Date.parse(booking.hold_expires_at);
  if (Number.isNaN(expiry)) return null;
  const serverMs = booking.server_now ? Date.parse(booking.server_now) : NaN;
  const offset = Number.isNaN(serverMs) ? 0 : serverMs - syncDeviceMs;
  return Math.max(0, Math.floor((expiry - (nowMs + offset)) / 1000));
}

export function useHoldCountdown(booking, onExpire) {
  const [left, setLeft] = useState(null);
  const expiredRef = useRef(false);
  useEffect(() => {
    expiredRef.current = false;
    if (!booking?.hold_expires_at) { setLeft(null); return; }
    const syncDeviceMs = Date.now();
    const tick = () => {
      const remaining = computeHoldRemaining(booking, syncDeviceMs, Date.now());
      setLeft(remaining);
      if (remaining === 0 && !expiredRef.current) {
        expiredRef.current = true;
        onExpire?.();
      }
    };
    tick();
    const t = setInterval(tick, 1000);
    return () => clearInterval(t);
  }, [booking?.hold_expires_at, booking?.server_now]); // eslint-disable-line react-hooks/exhaustive-deps
  return left;
}
